"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeChatAdapter = void 0;
const sample_data_1 = require("@home-health-notify/sample-data");
const utils_1 = require("../../utils");
/* eslint-disable @typescript-eslint/no-unused-vars */
class FakeChatAdapter {
    getLabRequisitions(chatId) {
        throw new Error("Method not implemented.");
    }
    createNewEpisode(data) {
        throw new Error("Method not implemented.");
    }
    syncPrivateChatList(data, organizationId, abortContext) {
        throw new Error("Method not implemented.");
    }
    syncBroadcastChatList(data, organizationId, abortContext) {
        throw new Error("Method not implemented.");
    }
    syncGroupChatList(data, organizationId, abortContext) {
        throw new Error("Method not implemented.");
    }
    addBroadcastGroup(data) {
        throw new Error(`Method not implemented.`);
    }
    addBroadcastMembers(data) {
        throw new Error(`Method not implemented.`);
    }
    addGroup(data) {
        throw new Error(`Method not implemented.`);
    }
    addMembers(data) {
        throw new Error(`Method not implemented.`);
    }
    deleteBroadcastGroup(broadcastId) {
        throw new Error(`Method not implemented.`);
    }
    enableDisableGroupEmail(requestData) {
        throw new Error(`Method not implemented.`);
    }
    getBroadcastChatList(data) {
        throw new Error(`Method not implemented.`);
    }
    getBroadcastInfo(broadcastId, source, context) {
        throw new Error(`Method not implemented.`);
    }
    getChatList(data) {
        throw new Error(`Method not implemented.`);
    }
    getExportChats(params, context) {
        throw new Error(`Method not implemented.`);
    }
    getGroupAssets(chatId, assetType, params) {
        throw new Error(`Method not implemented.`);
    }
    getGroupChatList(data, context) {
        return Promise.resolve((0, utils_1.CompletedResult)(sample_data_1.searchedGroupChatData.data));
    }
    getGroupInfo(groupId, source, context) {
        throw new Error(`Method not implemented.`);
    }
    getNonPatientGroups(params, context) {
        throw new Error(`Method not implemented.`);
    }
    getPrivateChatList(data, context) {
        throw new Error(`Method not implemented.`);
    }
    hideUnHideGroup(data) {
        throw new Error(`Method not implemented.`);
    }
    initiateExportChat(params) {
        throw new Error(`Method not implemented.`);
    }
    initiateExportMedia(params) {
        throw new Error(`Method not implemented.`);
    }
    revokeReferral(data) {
        throw new Error(`Method not implemented.`);
    }
    advanceSearch(advanceSearchPayload) {
        throw new Error(`Method not implemented.`);
    }
    fetchRecentContacts(params, context) {
        throw new Error("Method not implemented.");
    }
    getChatTemplates() {
        throw new Error(`Method not implemented.`);
    }
    getTemplate(templateKey) {
        throw new Error(`Method not implemented.`);
    }
    getRpmReading(params) {
        throw new Error(`Method not implemented.`);
    }
    managePatientDevice(params) {
        throw new Error(`Method not implemented.`);
    }
    exportRequest(params) {
        return Promise.resolve(undefined);
    }
    updateVisibleToPatient(data) {
        throw new Error(`Method not implemented.`);
    }
    updateVisibleToPhysician(data) {
        throw new Error(`Method not implemented.`);
    }
    leaveAndDeleteGroup(data) {
        throw new Error(`Method not implemented.`);
    }
    muteNotifications(data) {
        throw new Error(`Method not implemented.`);
    }
    deleteGroup(data) {
        throw new Error(`Method not implemented.`);
    }
    getAssignedPatients(userId, context) {
        throw new Error(`Method not implemented.`);
    }
    getUserMedia(userId, context) {
        throw new Error(`Method not implemented.`);
    }
    removeMember(data) {
        throw new Error(`Method not implemented.`);
    }
    removeBroadcastMember(data) {
        throw new Error(`Method not implemented.`);
    }
}
exports.FakeChatAdapter = FakeChatAdapter;
